import { connect } from 'react-redux';
import React, { Component } from 'react'

const mapStateToProps = state => ({
  ...state.common,
});


class ApiModal extends Component {
   
  render() {
    return (
    <div className="modal fade" id={(this.props.currentUrl).replace('https:', '').replace(/\//g, '').replace(/\=/g, '').replace(/\./g, '').replace(/\?/g, '').replace(/&/g, '').replace(/,/g, '')} role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">

              <h4 className="modal-title">Program Interface (‘API’)</h4>
            </div>
            <div className="modal-body">
              {this.props.isFirebaseEnabled && <p><b>Headers:</b><code className="break-line">{"{"}"headers": {"{"} USER_ID_TOKEN: *****Token*****{"}}"}</code></p>}
              <p><b>API Call:</b><code className="api-modal-block break-line">{this.props.currentUrl} </code></p>
              <p><b>API Response:</b><code className="api-modal-block break-line">{this.props.apiResponse}</code></p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(ApiModal);


// WEBPACK FOOTER //
// ./src/components/ApiModal.js